<template>
  <div class="container bigger-top-margin">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Ledgers</div>

          <div class="card-body">
            <p>So… “what exactly is a <b>ledger</b>”? Excellent question, glad you asked! Think of it as though your wallet, your personal calendar and your daily diary got together and decided to have a baby. That’s how a ledger is born!</p>
            <p>It helps you track your daily spendings, plan recurring or future expenses in advance, and make financial estimates without you worrying about doing any math for that.</p>
            <p>Oh, and you can create as many as you want! One for each project, life area or majestic goal, if you feel like it.</p><br>
            <div class="row">
              <div class="col-md-6">
                <h5>Create ledger</h5>
                There are exactly 5 clicks for having a brand new ledger:
                <ul>
                  <li>1st click: the upper-left Main Menu icon <i aria-hidden="true" class="pe pe-user-circle-o"/></li>
                  <li>2nd click: "Create ledger" option from the menu</li>
                  <li>3rd click: "Name" field, and enter a name for your ledger</li>
                  <li>4th click: "Currency" field, to specify any desired currency</li>
                  <li>5th click: "Create" button</li>
                </ul>
                And pooof, you're done!<br>
                See, it doesn't get any simpler than this.<br>
                <br>
                P.S. In case you need a little inspiration, you can use the <a href="/#/support/example-ledger">Example ledger</a> template to kickstart your very first ledger, or any new ledger going forward.<br>
                <br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/create-ledger.png" class="mb-2"/>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-6">
                <h5>Edit ledger</h5>
                <p>Now you have a ledger, but you're not quite happy with the name or the currency?</p>
                <p>No problem, we've got you covered!</p>
                <p>Simply click on the Ledger Settings icon <i aria-hidden="true" class="pe pe-cogs"/>, next to the ledger's name, and you can edit those two fields in the Details tab.</p>
                Don't forget to hit Save! Just sayin' ...<br>
                <br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/edit-ledger.png" class="mb-2"/>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-6">
                <h5>Share ledger</h5>
                <p>Because great things are worth sharing, we made it possible and so very simple for you to "parade" your ledgers!</p>
                <p>Just hit the Sharing tab within the Ledger Settings pop-up, and wow someone with your exquisite financial planning skills.</p>
                <p><i>One small detail though: that someone must also have an Expense Guide account, and have their email address in our database — because, well... <a href="https://eugdpr.org/" target="_blank">GDPR!</a></i></p>
                <br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/share-ledger.png" class="mb-2"/>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-6">
                <h5>Remove ledger</h5>
                <p>There comes a time when goodbyes are in order, and you just feel like releasing one of your ledgers into the abyss.</p>
                <p>We get it, some relationships simply don't last forever (unlike ours, of course!).</p>
                <p>Well, if you must, just open the Remove tab from Ledger Settings, fill out your account password, shed a tear, and then hit the Destroy button with no regrets!</p>
                Aaaaand, off it goes!<br>
                <br>
              </div>
              <div class="col-md-6">
                <b-img right rounded thumbnail fluid src="/img/support/remove-ledger.png" class="mb-2"/>
              </div>
            </div>
            <br>
            <br>
          </div>
          <div class="floating-bottom-container"><button onclick="window.history.back()" class="btn btn-primary floating-bottom-right">Go Back</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ledgers',
  data () {
    return {}
  }
}
</script>
